import React from 'react';
import {render} from 'react-dom';
import Grid from "@material-ui/core/Grid";
import Sidebar from './containers/Sidebar'
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import {ThemeProvider} from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import {connect, Provider} from "react-redux";
import LoginRegister from "./containers/Auth/LoginRegister";
import store from './store'
import {authCheck} from "./store/actions/auth";
import {MuiThemeProvider} from "material-ui";
import {getBalance, getTariffs} from "./services/authService";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import {hideAlert, hideSuccessAlert} from "./store/actions/common";
import Collapse from "@material-ui/core/Collapse";
import Fade from "@material-ui/core/Fade";

let theme = createMuiTheme({
    palette: {
        primary: {
            main: '#95c61c'
        },
        action: {
            main: '#f8a80d'
        }

        // secondary: {
        //     main: '#95c61c',
        //     light: '#b2d164'
        // },
    },
    // typography: {
    //     pxToRem: size => `${(size / htmlFontSize) * coef}rem`,
    //     // In Chinese and Japanese the characters are usually larger,
    //     // so a smaller fontsize may be appropriate.
    //     //pxToRem: size => size + 'px',
    //
    // },
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontSize: "10px",
            }
        },

    }

});

class App extends React.Component {

    componentDidMount() {
        this.props.dispatch(authCheck());
        this.props.dispatch(getBalance());
        this.props.dispatch(getTariffs());
        setInterval(() => this.props.dispatch(authCheck()), 1000000);
        setInterval(() => this.props.dispatch(getBalance()), 1000000);
    }

    render() {

        const{showErrorAlert, errorTitle, errorMessage, successTitle, successMessage, showSuccessAlert, dispatch} = this.props
        return (

            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <ThemeProvider theme={theme}>

                    <Fade style={{position: "fixed", width: '400px', top: '10%', right: '55px', zIndex: 10000}} in={showErrorAlert}>
                        <Alert severity="error" variant="filled" onClose={() => dispatch(hideAlert())}>
                            <AlertTitle>{errorTitle}</AlertTitle>
                            {errorMessage}
                        </Alert>
                    </Fade>

                    <Fade style={{position: "fixed", width: '400px', top: '10%', right: '55px', zIndex: 10000}} in={showSuccessAlert} >
                        <Alert severity="success" variant="filled" onClose={() => dispatch(hideSuccessAlert())}>
                            <AlertTitle>{successTitle}</AlertTitle>
                            {successMessage}
                        </Alert>
                    </Fade>

                    <Grid container>
                        {this.props.isAuthenticated ? <Sidebar/> : <LoginRegister/>}
                    </Grid>

                </ThemeProvider>
            </MuiPickersUtilsProvider>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        isAuthenticated: store.Auth.isAuthenticated,
        showErrorAlert: store.Common.showErrorAlert,
        errorTitle: store.Common.errorTitle,
        errorMessage: store.Common.errorMessage,
        successTitle: store.Common.successTitle,
        successMessage: store.Common.successMessage,
        showSuccessAlert: store.Common.showSuccessAlert
    }
}
export default connect(mapStateToProps)(App);